
import Vue from "vue";
import { communicationMapState } from "@/store/modules/communication";
import { isValid, format, parseISO } from "date-fns";
import { unescape } from "lodash";

export default Vue.extend({
  name: "CommunicationPreview",
  methods: {
    formatDate(dateString: string): string {
      const potentialDate = parseISO(dateString);
      if (isValid(potentialDate))
        return format(potentialDate, "M/d/yyyy h:mm:ss a");
      else return "N/A";
    }
  },
  computed: {
    ...communicationMapState(["editing"]),
    notificationMessage(): string {
      const message = this.editing.message || "";
      return unescape(message);
    },
    formattedDeliveryMethods(): string {
      if (this.editing) {
        return this.editing.alternateDeliveryMethods
          .map((method: string) => method.toUpperCase())
          .join(" - ");
      } else {
        return "N/A";
      }
    },
    formattedPriority(): string {
      if (this.editing) return this.editing.priority.toUpperCase();
      else return "N/A";
    }
  }
});
